var map = {
	"./blank-asset.svg": 353,
	"./btc.svg": 841,
	"./checkCopy.svg": 248,
	"./clock.svg": 249,
	"./close.svg": 250,
	"./copy.svg": 65,
	"./dai.svg": 842,
	"./dropdownTick.svg": 251,
	"./error.svg": 252,
	"./eth.svg": 843,
	"./facebookicon.svg": 253,
	"./githubicon.svg": 254,
	"./greenDot.svg": 844,
	"./info.svg": 255,
	"./liqualityLogo.svg": 134,
	"./lock.svg": 845,
	"./mediumicon.svg": 256,
	"./newLock.svg": 257,
	"./rbtc.svg": 846,
	"./spinner.svg": 847,
	"./switch.svg": 258,
	"./telegramicon.svg": 259,
	"./tick.svg": 91,
	"./twittericon.svg": 260,
	"./uni.svg": 848,
	"./usdc.svg": 849,
	"./usdt.svg": 850,
	"./wallets/ledger/device.svg": 87,
	"./wallets/ledger/icon.svg": 137,
	"./wallets/liquality/icon.svg": 247,
	"./wallets/metamask/icon.svg": 246,
	"./wallets/node/icon.svg": 177,
	"./warningRed.svg": 261,
	"./wbtc.svg": 851,
	"./webicon.svg": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;